import request from '@/router/axios'; // 新增报警

export var addObj = function addObj(param) {
  return request({
    url: "/api/alarm",
    method: 'POST',
    data: param
  });
}; // 修改报警

export function editObj(param) {
  return request({
    url: "/api/alarm",
    method: 'PUT',
    data: param
  });
} // 删除报警

export function deleteObj(param) {
  return request({
    url: "/api/alarm/".concat(param.id),
    method: 'delete'
  });
} // 报警分页查询

export function getList(param) {
  console.log(param, '--');
  return request({
    url: "/api/alarm/page",
    method: 'get',
    params: param
  });
} // 新增报警联系人

export var addObjContact = function addObjContact(data) {
  return request({
    url: "/api/contact",
    method: 'POST',
    data: data
  });
}; // 修改报警联系人

export function editObjContact(param) {
  return request({
    url: "/api/contact",
    method: 'PUT',
    data: param
  });
} // 删除报警联系人

export function deleteObjContact(param) {
  return request({
    url: "/api/contact/".concat(param.id),
    method: 'delete'
  });
} // 字典查询

export function dictType(type) {
  return request({
    url: "/api/blade-system/dict-biz/dictionary",
    method: 'get',
    params: {
      code: type
    }
  });
} // 报警联系人分页查询

export function getListContact(param) {
  return request({
    url: "/api/contact/page",
    method: 'get',
    params: param
  });
} // 报警联系人查询

export function getAllContact(param) {
  return request({
    url: "/api/contact/list",
    method: 'get',
    params: param
  });
} // 报警数据查询

export function getAlarmData(param) {
  return request({
    url: "/api/alarm/data/page",
    method: 'get',
    params: param
  });
} // 监控点查询

export function getMonitorList(param) {
  return request({
    url: "/api/alarm/monitor/list",
    method: 'get',
    params: param
  });
} // 报警数据详情查询

export function getAlarmDetail(param) {
  return request({
    url: "/api/alarm/".concat(param.id),
    method: 'get',
    params: param
  });
} // 报警数历史数据

export function getHistory(param) {
  return request({
    url: "/api/alarm/history/page",
    method: 'get',
    params: param
  });
} // 查询报警日期

export function alarmDateList(param) {
  return request({
    url: "/api/alarm/date/list/".concat(param.alarmId),
    method: 'get',
    params: param
  });
} // 项目设备列表

export function getProjectAndDeviceList(param) {
  return request({
    url: "/api/project/getProjectAndDeviceList",
    method: 'get',
    params: param
  });
}